<template>
	<div>
		<action-sidebar
			title="Asignar Barra de Acciones"
			:value="true"
			@close-modal="closeModal"
		>
			<resource-action-form
				:code-project="codeProject"
				:resource-id="id"
				:resource-name="name"
			/>
		</action-sidebar>
	</div>
</template>

<script>
	import actionSidebar from '@/components/shared/action-sidebar';
	import resourceActionForm from '@/components/resources/resource-action-form';

	function closeModal() {
		this.goTo('page-resource');
	}

	export default {
		name: 'page-resource-action',
		components: {
			actionSidebar,
			resourceActionForm,
		},
		methods: {
			closeModal,
		},
		props: {
			id: {
				type: [Number, String],
			},
			codeProject: {
				type: String,
			},
			name: {
				type: String,
				required: true,
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/pages/resources/page-resource-action.vue